import { render } from "./ProductComparisonTableValue.vue?vue&type=template&id=01de132d"
import script from "./ProductComparisonTableValue.vue?vue&type=script&lang=js"
export * from "./ProductComparisonTableValue.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__